import React from "react";

export const AnalyticsButton = ({
    label,
    handler,
    isSelected
}) => {
    return (
        <div className="flex">
            <button 
                onClick={() => handler(label)}
                className={`
                    w-[200px] h-[50px] rounded-2xl shadow-md transition-colors duration-300
                    font-nunito font-medium text-base
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
                    ${isSelected 
                        ? "bg-indigo-600 text-white" 
                        : "bg-white text-black hover:bg-gray-100"}
                `}
            >
                {label}
            </button>
        </div>
    );
};